// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NcdQ","type":"styles_type__ImD4T","choices":"styles_choices__1vKKN"};